export const isRoistatReady = (win: Window): win is typeof win & { roistat: { getVisit: () => string } } => {
  const roistat = (win as any).roistat;

  return roistat && typeof roistat.getVisit === 'function';
};
